import React from 'react';
import PropTypes from 'prop-types';

const ENTER_KEY = 13;

export function HeaderContainer(props) {
  const onKeyDown = (event) => event.keyCode === ENTER_KEY && props.onClick();

  return (
    <div
      className={props.className}
      onClick={props.onClick}
      tabIndex={props.tabIndex}
      onKeyDown={onKeyDown}>
      {props.children}
    </div>
  );
}

HeaderContainer.propTypes = {
  /**
   * ClassName passed outside from component
   */
  className: PropTypes.string,
  /**
   * Which is used for keyboard navigation
   */
  tabIndex: PropTypes.number,
  /**
   * function to invoke the transcription details
   */
  onClick: PropTypes.func,
};
